import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { img, IMG } from "@/lib/site";

const STORAGE_KEY = "hod_newsletter_seen";

export const NewsletterPopup = () => {
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);

  useEffect(() => {
    let seen = false;
    try {
      seen = localStorage.getItem(STORAGE_KEY) === "1";
    } catch (e) {}
    if (seen) return;
    const t = setTimeout(() => setOpen(true), 2600);
    return () => clearTimeout(t);
  }, []);

  const dismiss = () => {
    try {
      localStorage.setItem(STORAGE_KEY, "1");
    } catch (e) {}
    setOpen(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!email || !/^\S+@\S+\.\S+$/.test(email)) {
      toast.error("Please enter a valid email address.");
      return;
    }
    setDone(true);
    toast.success("Thank you — you're on the list.");
    try {
      localStorage.setItem(STORAGE_KEY, "1");
    } catch (e) {}
    setTimeout(() => setOpen(false), 1600);
  };

  return (
    <Dialog open={open} onOpenChange={(v) => (v ? setOpen(true) : dismiss())}>
      <DialogContent
        data-testid="newsletter-popup"
        className="max-w-3xl overflow-hidden border-none p-0 sm:rounded-none"
      >
        <DialogTitle className="sr-only">Subscribe to the House of David newsletter</DialogTitle>
        <div className="grid grid-cols-1 md:grid-cols-2">
          <div className="hidden md:block">
            <img
              src={img(IMG.beamsShadow, 900)}
              alt="House of David interiors"
              className="h-full w-full object-cover"
            />
          </div>
          <div className="flex flex-col justify-center p-8 md:p-12">
            <span className="eyebrow">House of David</span>
            {done ? (
              <div data-testid="newsletter-success">
                <h2 className="mt-4 text-2xl font-light tracking-editorial md:text-3xl">
                  Welcome.
                </h2>
                <p className="mt-4 text-sm leading-relaxed text-muted-foreground">
                  Thank you for subscribing. We'll be in touch with new collections and
                  design inspiration.
                </p>
              </div>
            ) : (
              <>
                <h2 className="mt-4 text-2xl font-light leading-tight tracking-editorial md:text-3xl">
                  Subscribe to our newsletter
                </h2>
                <p className="mt-4 text-sm leading-relaxed text-muted-foreground">
                  Be first to see new collections and considered
                  interior inspiration — direct from our Auckland studio.
                </p>
                <form onSubmit={handleSubmit} className="mt-8" data-testid="newsletter-form">
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Your email address"
                    data-testid="newsletter-email"
                    className="w-full border-b border-foreground/30 bg-transparent py-3 text-sm tracking-editorial outline-none transition-colors focus:border-foreground"
                  />
                  <button
                    type="submit"
                    data-testid="newsletter-submit"
                    className="mt-6 w-full bg-primary px-8 py-4 text-sm uppercase tracking-[0.16em] text-primary-foreground transition-opacity hover:opacity-90"
                  >
                    Subscribe →
                  </button>
                </form>
                <button
                  type="button"
                  onClick={dismiss}
                  data-testid="newsletter-dismiss"
                  className="mt-5 text-xs uppercase tracking-[0.16em] text-muted-foreground transition-colors hover:text-foreground"
                >
                  No thanks
                </button>
              </>
            )}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
